import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import SelectInput from '../../../../../modules/react/components/stateful/SelectInput';
import useCurrentPageData from '../../../../../modules/react/hooks/useCurrentPageData';

const GET_FACILITIES = gql`
  query GetFacilities(
    $live: Boolean!, $locale: String!, $listingType: ListingTypeEnum!, $sortParameters: FacilitiesSortInput,
  ) {
    facilities(
      filter: { live: $live, locale: $locale, listingType: $listingType },
      sortParameters: $sortParameters,
    ) {
      edges {
        node {
          id
          displayName
          address {
            fullAddress
          }
        }
      }
    }
  }
`;

const LiveFacilitySelect = ({
  ...rest
}) => {
  const { locale } = useCurrentPageData();
  const {
    data,
    loading,
    error,
  } = useQuery(GET_FACILITIES, {
    variables: {
      live: true,
      locale,
      listingType: 'full',
      sortParameters: {
        sortBy: 'displayName',
        sortDirection: 1,
      },
    },
    ssr: false,
  });

  if (!data || loading) {
    return null;
  }

  const facilities = error ? [] : data.facilities.edges.map(({ node }) => node);

  const options = facilities.reduce((opts, {
    id,
    displayName,
    address: { fullAddress },
  }) => {
    opts[id] = `${displayName} - ${fullAddress}`;
    return opts;
  }, {});

  return <SelectInput options={options} {...rest} htmlSelect />;
};

export default LiveFacilitySelect;
